import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, MessageCircle, X } from "lucide-react";
import { Logo } from "./Logo";
import { DEFAULT_WHATSAPP_MESSAGE, PAINEL_URL, whatsappLink } from "../lib/constants";

const NAV_ITEMS = [
  { to: "/", label: "Inicio" },
  { to: "/whatsapp-web", label: "API Web (QR Code)" },
  { to: "/whatsapp-oficial", label: "API Oficial" },
  { to: "/sms", label: "SMS" },
  { to: "/planos", label: "Planos" },
];

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b-2 border-ink bg-paper/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3">
        <Link to="/" className="flex items-center gap-2" onClick={() => setOpen(false)}>
          <Logo className="h-14" />
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium transition ${
                  isActive ? "bg-ink text-white" : "text-ink/70 hover:bg-ink/5 hover:text-ink"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a href={PAINEL_URL} className="text-sm font-semibold text-ink hover:underline">
            Login
          </a>
          <a
            href={whatsappLink(DEFAULT_WHATSAPP_MESSAGE)}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 rounded-lg border-2 border-ink bg-brand-600 px-4 py-2 text-sm font-bold text-white shadow-solid-sm transition hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-solid"
          >
            <MessageCircle size={16} /> Falar no WhatsApp
          </a>
        </div>

        <button
          className="rounded-md border-2 border-ink p-2 lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Abrir menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="border-t-2 border-ink bg-paper px-5 py-4 lg:hidden">
          <nav className="flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2 text-sm font-medium ${
                    isActive ? "bg-ink text-white" : "text-ink/70"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <a href={PAINEL_URL} className="mt-2 rounded-md px-3 py-2 text-sm font-semibold text-ink">
              Login
            </a>
            <a
              href={whatsappLink(DEFAULT_WHATSAPP_MESSAGE)}
              target="_blank"
              rel="noreferrer"
              className="mt-1 flex items-center justify-center gap-2 rounded-lg border-2 border-ink bg-brand-600 px-4 py-2 text-sm font-bold text-white"
            >
              <MessageCircle size={16} /> Falar no WhatsApp
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
